export const rffDependentGroupStyles = {
  ml: 1,
  borderLeft: `2px solid var(--titleColor)`,
  pl: 3,
  pt: 2,
  pb: 1,
  mt: -2,
  mb: "8px !important",
  background:
    "linear-gradient(90deg, rgba(43,34,102,0.04) 0%, rgba(255,255,255,1) 100%)",
};
